import { render, staticRenderFns } from "./SectionContentImage.vue?vue&type=template&id=7082aecf&scoped=true&"
import script from "./SectionContentImage.vue?vue&type=script&lang=js&"
export * from "./SectionContentImage.vue?vue&type=script&lang=js&"
import style0 from "./SectionContentImage.vue?vue&type=style&index=0&id=7082aecf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7082aecf",
  null
  
)

export default component.exports